import React from "react"
import {IconButton, IconButtonProps} from "../IconButton/IconButton"
import classNames from "classnames"

type AIInsightsButtonProps = Omit<IconButtonProps, "icon" | "variant"> & {
	variant?: IconButtonProps["variant"]
	withIndicator?: boolean
	className?: string
}

export function AIInsightsButton({
	variant = "outline",
	withIndicator = true,
	className,
	...props
}: AIInsightsButtonProps) {
	return (
		<span className={classNames("ai-insights-button", className)}>
			<IconButton
				icon="ai-insight-recommend"
				variant={variant}
				withIndicator={withIndicator}
				className="is-fullwidth"
				{...props}
			/>
		</span>
	)
}

export default AIInsightsButton
